import React from 'react'
import { CardMedia, Skeleton } from '@mui/material'
import ArticleSummary from './article-summary'
import ArticleCardContainer from './article-card-container'
import makeStyles from '@mui/styles/makeStyles'
import { image } from '../../placeholder'

// MT.3: image-over-text portrait layout; image takes full width with
// rounded corners. Removed the legacy negative-top + inset-left trick that
// pulled the summary panel up over the image — summary now flows directly
// below the image like the rest of the refreshed cards.
export const useStyles = makeStyles(({ palette, spacing, breakpoints, radius }) => ({
  image: {
    width: '100%',
    height: 180,
    borderRadius: radius.lg
  },
  summary: {
    paddingTop: spacing(2)
  },
  title: {
    fontWeight: 700
  }
}))

const ArticleCardPortrait = ({ onSelect, article }) => {
  const classes = useStyles()
  return (
    <ArticleCardContainer article={article} onSelect={onSelect}>
      {article
        ? <CardMedia
            image={(article.image?.imgUrl ?? image) + 'h=360'}
            title='alt text here'
            className={classes.image}
            data-test={`article-card-image-${article?.friendlyUrl}`}
          />
        : <Skeleton variant='rectangular' className={classes.image} />}
      <ArticleSummary
        article={article}
        className={classes.summary}
        classes={{ title: classes.title }}
      />
    </ArticleCardContainer>
  )
}

export default ArticleCardPortrait
